export default __webpack_public_path__ + "static/media/2_icon5B.950e2b8c.png";